/*
 * "More" menu for the section bar on narrow desktops (from Ghost's Source theme).
 * Sections that don't fit are moved into a dropdown at the end of the bar.
 *
 * YV Indy accessibility changes (0.5.0):
 * - The menu is now <li><button/><ul>…</ul></li>. Source put the links INSIDE
 *   the button, which screen readers and keyboards can't use properly, and put
 *   a <button> straight into the <ul>, which isn't valid.
 * - The button reports open/closed (aria-expanded) and Escape closes the menu.
 * - One set of listeners for the page; Source added another on every resize.
 */
function dropdown() {
    const mediaQuery = window.matchMedia('(max-width: 767px)');

    const head = document.querySelector('.gh-navigation');
    const menu = head.querySelector('.gh-navigation-menu');
    const nav = menu?.querySelector('.nav');
    if (!nav) return;

    const logo = document.querySelector('.gh-navigation-logo');
    const navHTML = nav.innerHTML;

    if (mediaQuery.matches) {
        const items = nav.querySelectorAll('li');
        items.forEach(function (item, index) {
            item.style.transitionDelay = `${0.03 * (index + 1)}s`;
        });
    }

    const setOpen = function (open) {
        head.classList.toggle('is-dropdown-open', open);
        const toggle = nav.querySelector('.gh-more-toggle');
        if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    const makeDropdown = function () {
        if (mediaQuery.matches) return;
        const submenuItems = [];

        while ((nav.offsetWidth + 64) > menu.offsetWidth) {
            if (nav.lastElementChild) {
                submenuItems.unshift(nav.lastElementChild);
                nav.lastElementChild.remove();
            } else {
                break;
            }
        }

        if (!submenuItems.length) {
            head.classList.add('is-dropdown-loaded');
            return;
        }

        const more = document.createElement('li');
        more.setAttribute('class', 'yv-more');

        const toggle = document.createElement('button');
        toggle.setAttribute('class', 'gh-more-toggle gh-icon-button');
        toggle.setAttribute('type', 'button');
        toggle.setAttribute('aria-label', 'More sections');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-controls', 'gh-more-menu');
        toggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor" aria-hidden="true" focusable="false"><path d="M21.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM13.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM5.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0z"></path></svg>';

        const wrapper = document.createElement('ul');
        wrapper.setAttribute('class', 'gh-dropdown');
        wrapper.setAttribute('id', 'gh-more-menu');

        if (submenuItems.length >= 10) {
            head.classList.add('is-dropdown-mega');
            wrapper.style.gridTemplateRows = `repeat(${Math.ceil(submenuItems.length / 2)}, 1fr)`;
        } else {
            head.classList.remove('is-dropdown-mega');
        }

        submenuItems.forEach(function (child) {
            wrapper.appendChild(child);
        });

        more.appendChild(toggle);
        more.appendChild(wrapper);
        nav.appendChild(more);

        const toggleRect = toggle.getBoundingClientRect();
        const documentCenter = window.innerWidth / 2;

        if (toggleRect.left < documentCenter) {
            wrapper.classList.add('is-left');
        }

        head.classList.add('is-dropdown-loaded');
    };

    // Click the "…" button to open; any click while open closes it
    // (a click on a section link still follows the link).
    window.addEventListener('click', function (e) {
        const toggle = nav.querySelector('.gh-more-toggle');
        if (head.classList.contains('is-dropdown-open')) {
            setOpen(false);
        } else if (toggle && toggle.contains(e.target)) {
            setOpen(true);
        }
    });

    // Escape closes the menu and returns focus to the button
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && head.classList.contains('is-dropdown-open')) {
            setOpen(false);
            const toggle = nav.querySelector('.gh-more-toggle');
            if (toggle) toggle.focus();
        }
    });

    imagesLoaded(logo, function () {
        makeDropdown();
    });

    window.addEventListener('load', function () {
        if (!logo) {
            makeDropdown();
        }
    });

    window.addEventListener('resize', function () {
        setTimeout(() => {
            setOpen(false);
            nav.innerHTML = navHTML;
            makeDropdown();
        }, 1);
    });
}
